<template>
  <div id="app">
      <div class="page-target">
        <mt-button type="default" size="large" plain @click.native="gogogo">To Appcall Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="tototo">To Calendar Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="budget">预算</mt-button>
        <mt-button type="primary" size="large" plain @click.native="goChart">To F2Chart Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="goLovesway">To Lovesway Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="goTask">To Task Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="goRegistry">To Registry Page</mt-button>
        <mt-button type="primary" size="large" plain @click.native="goVows">To Vows Page</mt-button>
      </div>
  </div>
</template>

<script>
import modal from '../../components/modal.vue'
export default {
  components: {
    modal
  },
  data() {
    return {
      msg: 'Use Vue 2.0 Today!'
    }
  },
  mounted() {
    console.log(process.env.VUE_APP_URL)
  },
  methods: {
    gogogo() {
      location.assign('../preview/appcall.html') // alias:'../pintu'
    },
    tototo() {
      location.assign('../luckyday/index.html') // alias:'../calendar'
    },
    budget() {
      location.assign('../budget/index.html')
    },
    goChart() {
      location.assign('../preview/index.html')
    },
    goLovesway() {
      location.assign('../lovesway/index.html')
    },
    goTask() {
      location.assign('../task/index.html')
    },
    goRegistry() {
      location.assign('../registry/index.html')
    },
    goVows() {
      location.assign('../vows/index.html')
    },
  }
}
</script>

<style lang="less">
.page-target {
  .mint-button {
    margin: 10px 0;
  }
}
</style>
